import { useOfferPageContext } from 'pages/offer/context';
import { BenefitKeys, CardVariant } from 'pages/offer/types';
import medIcon from '../icons/med.svg';
import studyIcon from '../icons/study.svg';
import selebrateIcon from '../icons/selebrate.svg';
import bonusIcon from '../icons/bonus.svg';
import itIcon from '../icons/it.svg';
import styles from './benefits.module.scss';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import { Typography, TypographyType, TypographyColor } from './typography';
import { Card, ListWithDots } from '.';

const benefitIcons: Record<BenefitKeys, string> = {
  MedInsurance: medIcon,
  CorporateLife: selebrateIcon,
  Bonus: bonusIcon,
  Education: studyIcon,
};

const beTechId = '10';

/**
 * Benefits blocks
 */
export const Benefits = () => {
  const {
    userData: { benefits, businessUnit },
  } = useOfferPageContext();

  return (
    <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.benefits}>
      <Typography type={TypographyType.h2}>Соцпакет и бенефиты</Typography>

      <div className={styles.blocks}>
        {benefits.map((benefit) => (
          <Card key={benefit.title} variant={CardVariant.benefit} className={styles.benefitBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleBenefit} className={styles.benefitTitle}>
              {benefit.title.toUpperCase()}
              <img className={styles.icon} src={benefitIcons[benefit.benefit_key]} />
            </Typography>

            <ListWithDots>
              {benefit.items.map((b) => (
                <Typography key={b}>{b}</Typography>
              ))}
            </ListWithDots>
          </Card>
        ))}

        {businessUnit.id === beTechId && (
          <Card variant={CardVariant.benefit} className={styles.benefitBlock}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleBenefit} className={styles.benefitTitle}>
              АККРЕДИТОВАННАЯ ИТ-КОМПАНИЯ
              <img className={styles.icon} src={itIcon} />
            </Typography>

            <Typography className={styles.itPrivilegesText}>
              На нас расспространяются все привелегии для аккредитованных ИТ-компаний
            </Typography>
          </Card>
        )}
      </div>
    </Spacing>
  );
};
